var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-consent-blocker"},[_c('div',{staticClass:"c-consent-blocker__content"},[_c('RichText',{attrs:{"data":_vm.description}}),_vm._v(" "),_c('ButtonComponent',{attrs:{"type":"button","variant":"primary","label":_vm.buttonLabel},on:{"click":_vm.unblockService}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }